import React, { useState } from 'react'
import { contactMessage } from '../Services/allAPIs';
import { motion} from 'framer-motion'

function Contact() {

  const [normalInput,setNormalInput] = useState({
    senderName:"",
    senderEmail:"",
    message:""
  })

  const setUserInputs = (e) =>{
    console.log(e.target);
    const {name,value} = e.target
    setNormalInput({...normalInput,[name]:value})
  }

  const contact = async (e) => {
    e.preventDefault();
    console.log("bla");
    const {senderName,senderEmail,message} = normalInput
    if(!senderName || !senderEmail || !message){
      alert("Please Fill the Form Completely")
    }else{
      const data = {
        senderName:senderName,
        senderEmail:senderEmail,
        message:message
      }
      console.log(data);

      const response = await contactMessage(data)
      console.log(response);
      if(response.status === 200){
        alert("Message Sent Successfully")
        setNormalInput({...normalInput,
          senderName:"",
          senderEmail:"",
          message:""
        })
      }else{
        alert("Message Not Sent")
      }
    }
  }

  return (
    <>
    <motion.div className='row mt-5'
      variants={{
        hidden:{opacity:0},
        visible:{opacity:1}
      }}
      initial="hidden"
      animate="visible"
      transition={{duration:2,delay:0}}
    >
      <div className='col-lg-4 col-2'></div>
      <div className='col-lg-4 col-8' style={{}}>
        <form onSubmit={contact}>
          <div className='row mt-5'>
            <div class="col-6 form-floating mb-3">
              <input type="name" class="form-control" id="floatingInput" name='senderName' value={normalInput.senderName} onChange={setUserInputs}/>
              <label for="floatingInput">Name</label>
            </div>
            <div class="col-6 form-floating">
              <input type="email" class="form-control" id="floatingPassword" name='senderEmail' value={normalInput.senderEmail} onChange={setUserInputs}/>
              <label for="floatingPassword">Email</label>
            </div>
          </div>
          <div className='row'>
            <div class="col-12 form-floating">
              <textarea  class="form-control" id="floatingTextarea2" name='message' value={normalInput.message} onChange={setUserInputs} style={{height:"100px"}}></textarea>
              <label for="floatingTextarea2">Message</label>
            </div>
          </div>
          <div className='row mt-4'>
            <div className='col-4'></div>
            <div className='col-4 d-flex justify-content-center'>
              <button className='btn btn-dark'>Submit</button>
            </div>
            <div className='col-4'></div>
          </div>
        </form>
        <div className='row mt-5 mb-5'>
          <p className='d-flex justify-content-center'>
            <strong>Phone : +91 8113000923<br/> Email : bsharpmusic@gmail.com</strong>
          </p>
          
        </div>
      </div>
      <div className='col-lg-4 col-4'></div>
    </motion.div>
    </>
  )
}

export default Contact